export const COLORS = {
  HEADER_BK_HEX_COLOR: '#0C327C',
  HEADER_TEXT_HEX_COLOR: '#EED348',
};

export const FORM_SUBMIT_URL =
  'https://docs.google.com/forms/u/1/d/e/1FAIpQLSf2SUjVDnskakq1qdOFhV7Fy43mL2CdEByVV8v_ESPx62SKXQ/formResponse';

export const FORM_DATA_MAPPING = {
  TYPE: 'entry.469295222',
  FIRST_NAME: 'entry.1893249498',
  LAST_NAME: 'entry.1080063905',
  EMAIL: 'entry.386689938',
  COUNTRY: 'entry.1260204661',
  LANGUAGE: 'entry.543022172',
  TERMS: 'entry.973371017',
};

export const LIST_OF_COUNTRIES = [
  'AL',
  'AD',
  'AT',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MK',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'UA',
  'GB',
].reduce<{ [key: string]: boolean }>((acc, code) => {
  acc[code] = true;
  return acc;
}, {});
